import { ProfileResource } from "@medplum/core";
import { Encounter } from "@medplum/fhirtypes";

export function splitName(name: string) {
  return name.split(/(\s+)/).filter((x) => x.trim().length > 0);
}

/**
 *
 * @param name
 * @returns name with first initial and full last name
 */
export function formatName(name: string) {
  const [firstName, lastName] = name.split(" ");
  const initial = firstName.charAt(0);
  return `${initial}${lastName}`;
}

export function encodeString(str: string) {
  return encodeURIComponent(str).replace(/[()]/g, function (c) {
    return "%" + c.charCodeAt(0).toString(16);
  });
}

export const getName = (person: ProfileResource) => {
  const firstName = person?.name?.[0]?.given?.[0] ?? "";
  const lastName = person?.name?.[0]?.family ?? "";
  const fullName = `${firstName} ${lastName}`.trim();
  const initials = `${firstName[0] ?? ""}${lastName[0] ?? ""}`.toUpperCase();

  return { firstName, lastName, initials, fullName };
};

export function getInitials(name: string | undefined, fallback: string = "?"): string {
  if (!name || name.trim() === "") {
    return fallback;
  }

  const words = name
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0);

  if (words.length === 0) {
    return fallback;
  }

  if (words.length === 1) {
    return words[0][0].toUpperCase();
  }

  // For multiple words, take first letter of first and last word
  const firstLetter = words[0].charAt(0).toUpperCase();
  const lastLetter = words[words.length - 1].charAt(0).toUpperCase();
  return firstLetter + lastLetter;
}

export function getEncounterType(encounter: Encounter) {
  const encounterType = encounter.serviceType?.coding?.[0]?.code;
  return encounterType;
}

export function formatPhoneNumber(phoneNumber: string) {
  return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
}
